import { Component, inject } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SessionService } from "./core/session/session.service";

@Component({
  selector: "app-root",
  imports: [RouterModule],
  templateUrl: "./app.html",
})
export class App {
  private readonly session = inject(SessionService);

  constructor() {
    this.session.start();
  }
}
